import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type {
  IDashboardChartResponse,
} from '../types';
import {
  DASHBOARD_CHART_QUERY_KEY,
  DASHBOARD_CHART_URL,
  DASHBOARD_PERMISSIONS,
} from '../constants';

export default function useDashboardChartQuery(merchant: Ref<number | undefined>): IContextQueryResult<IDashboardChartResponse, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IDashboardChartResponse, Error>({
    queryKey: [DASHBOARD_CHART_QUERY_KEY, merchant],
    queryFn: ({ signal }) => fetchGet(DASHBOARD_CHART_URL, {
      signal,
      queryParams: { merchant: merchant.value },
      permission: DASHBOARD_PERMISSIONS.DASHBOARD_CHART,
    }),
    enabled: computed(() => !!merchant.value),
  });
}
